module.exports = __webpack_public_path__ + "img/Lose-win-min.7fe818a0.png";